import styled from 'styled-components';

export const EmojiWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
